import {Color} from '@benchling/nucleus-ui';

import {PublishingStatus} from 'graphql-client/__generated/graphqlGlobalTypes';
import {GRAY_SEMIDARK} from 'ui-library/Colors';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export enum DraftPublishableVersionStatus {
  DRAFT = 'DRAFT',
  DRAFT_NON_CURRENT = 'DRAFT_NON_CURRENT',
}

export type PublishableVersionStatus = PublishingStatus | DraftPublishableVersionStatus;

export const PublishableVersionStatus = {...PublishingStatus, ...DraftPublishableVersionStatus};

export enum PublishableVersionAction {
  CREATE_DRAFT = 'Create Draft',
  PUBLISH = 'Publish',
  WITHDRAW = 'Withdraw',
}

export const PUBLISHABLE_VERSION_STATUS_TO_ACTION_PAST_TENSE: Record<PublishableVersionStatus, string> = {
  [PublishableVersionStatus.DRAFT]: 'Drafted',
  [DraftPublishableVersionStatus.DRAFT_NON_CURRENT]: 'Drafted',
  [PublishableVersionStatus.EFFECTIVE]: 'Published',
  [PublishableVersionStatus.SUPERSEDED]: 'Superseded',
  [PublishableVersionStatus.WITHDRAWN]: 'Withdrawn',
};

export const PUBLISHABLE_VERSION_STATUS_TO_ICON: Record<PublishableVersionStatus, BenchlingIconName> = {
  [PublishableVersionStatus.DRAFT]: 'timer',
  [DraftPublishableVersionStatus.DRAFT_NON_CURRENT]: 'protocol-timer',
  [PublishableVersionStatus.EFFECTIVE]: 'file-check',
  [PublishableVersionStatus.SUPERSEDED]: 'file-minus',
  [PublishableVersionStatus.WITHDRAWN]: 'file-xmark',
};

export const PUBLISHABLE_VERSION_STATUS_TO_COLOR: Record<PublishableVersionStatus, string> = {
  [PublishableVersionStatus.DRAFT]: Color.BLUE_500,
  [DraftPublishableVersionStatus.DRAFT_NON_CURRENT]: GRAY_SEMIDARK,
  [PublishableVersionStatus.EFFECTIVE]: Color.GREEN_600,
  [PublishableVersionStatus.SUPERSEDED]: Color.YELLOW_600,
  [PublishableVersionStatus.WITHDRAWN]: Color.ORANGE_500,
};

export const PUBLISHABLE_VERSION_ACTION_TO_ICON: Record<PublishableVersionAction, BenchlingIconName> = {
  [PublishableVersionAction.CREATE_DRAFT]: PUBLISHABLE_VERSION_STATUS_TO_ICON[PublishableVersionStatus.DRAFT],
  [PublishableVersionAction.PUBLISH]: PUBLISHABLE_VERSION_STATUS_TO_ICON[PublishableVersionStatus.EFFECTIVE],
  [PublishableVersionAction.WITHDRAW]: PUBLISHABLE_VERSION_STATUS_TO_ICON[PublishableVersionStatus.WITHDRAWN],
};

export const CONTROLLED_VERSION_NAME_PREFIX = 'Version';
export const DEFAULT_VERSION_NAME = `${CONTROLLED_VERSION_NAME_PREFIX} 1`;
